var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page_header",style:({'--progress': 0, '--gradient': 'url(' + _vm.gradientBackground + ')'})},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"left",class:{'no-desc': !_vm.description}},[_c('h3',{attrs:{"data-highlightword":_vm.getWordsInFirstRow(_vm.title)},domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),(_vm.description)?_c('div',{staticClass:"right"},[_c('div',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.description)}})]):_vm._e(),_vm._v(" "),_c('scroll-button',{attrs:{"target_selector":".page_header","scroll_to_bottom":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/PageHeader.vue